import styled from "styled-components";

import { getOpacityColor, grayScale, red } from "@enkor/design/colors";

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
`;

export const Title = styled.span`
  margin-bottom: 8px;

  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
`;

export const Input = styled.input<{ $isError?: string | null }>`
  width: 100%;
  padding: 10px;
  border: 1px solid ${grayScale.main};
  border-radius: 8px;

  background-color: ${getOpacityColor(grayScale.black, 0.2)};

  color: ${grayScale.white};
  font-weight: 400;
  font-size: 14px;

  &:focus {
    border: 1px solid ${grayScale.white};
  }

  &::placeholder {
    color: ${grayScale.main};
  }
`;

export const ErrorMessage = styled.p`
  margin-top: 4px;

  color: ${red.main};
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
`;
